import $ from 'jquery';

export default class StaticCollection {
  constructor(section) {
    this.$el = $(section.el);

    $('.collection-tag-selector select', this.$el).on('change', (event) => this.browseByTag(event));
  }

  browseByTag(e) {
    const select = $(e.target);
    const fallback = select.data('fallback-url');
    const newTag = select.find(':selected').attr('name');

    if (newTag === 'reset') {
      window.location.href = fallback;
    } else {
      window.location.href = `${fallback}/${newTag}`;
    }
  }

  onSectionUnload() {
    $('.collection-tag-selector select', this.$el).off('change');
  }
}
